import React, {useEffect, useState, useContext} from "react";
import {Button, Col, Container, Row, Tab, Tabs} from "react-bootstrap";
import '../components/FrontProductsBlock.css';
import '../components/Catalog/catpanel.css';
import '../components/catalog.css';
import '../css/ImageGallery.css';
import { CartPlus, CartDash, CartX } from 'react-bootstrap-icons';
import {Context} from "..";
import {getProduct} from "../http/productAPI";
import {useParams, useNavigate} from "react-router-dom";
import ImageGallery from '../components/ProductCardComp/ImageGallery'
import ExpandableText from '../components/ProductCardComp/ExpandableText';
import RequestPriceModal from "../components/RequestPriceModal";
import {PRODUCT_ROUTE} from "../utils/const";
import Breadcrumbs from '../components/Catalog/Breadcrumbs';

  //    Словарь цветов
    const colorMap  = {
        "Бежевый": "#F5F5DC",          // Beige
        "Белый": "#FFFFFF",            // White
        "Белый матовый": "#F8F8F8",    // Matte White (слегка затемнённый белый)
        "Голубой": "#87CEEB",          // Sky Blue
        "Графит": "#4B4B4B",           // Graphite (тёмно-серый)
        "Золотой": "#FFD700",          // Gold
        "Красный": "#FF0000",          // Red
        "Серебристый": "#C0C0C0",      // Silver
        "Серый": "#808080",            // Gray
        "Серый матовый": "#A9A9A9",    // Dark Gray (матовость — тусклее)
        "Синий": "#0000FF",            // Blue
        "Синий антрацит": "#2F4F4F",   // Anthracite Blue (тёмно-синий, почти серый)
        "Слоновая кость": "#FFFFF0",   // Ivory
        "Черный": "#000000",           // Black
        "Черный матовый": "#1C1C1C",   // Matte Black (слегка осветлённый чёрный)
      };
 
    function isLightColor(color) {
      if (!color) return false;
      const c = color.substring(1); // убираем #
      const rgb = parseInt(c, 16);
      const r = (rgb >> 16) & 0xff;
      const g = (rgb >> 8) & 0xff;
      const b = (rgb >> 0) & 0xff;
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 180;
    }

const ProductCard = () => {
  const {user} = useContext(Context)
  const {product} = useContext(Context)
  const [productItem, setProductItem] = useState({})
  const [count, setCount] = useState(0)
  const {id} = useParams()
  const [modalShow, setModalShow] = useState(false);
  const [selectedArea, setSelectedArea] = useState(null);
  const [hoveredColor, setHoveredColor] = useState(null);
  const [selectedColor, setSelectedColor] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
  getProduct(id, user).then((data) => {
    setProductItem(data);

      // Найти площадь помещения по текущему товару
      if (data.productsOfLines) {
        const entries = Object.entries(data.productsOfLines);
        for (const [area, items] of entries) {
          const match = items.find((item) => item.id === data.id);
          if (match) {
            setSelectedArea(area);
            setSelectedColor(match.color || "");
            break;
          }
        }
      }
    });

  const basketItem = product.basketProducts?.find(bp => bp.id === id);
  setCount(basketItem?.count || 0);
}, [id, user, product.basketProducts]);

  // Обработка выбора площади помещения: сохранить выбранную площадь, сохранить цвет, перейти на нужный товар
  const handleAreaSelect = (area) => {
    setSelectedArea(area);
    if (productItem.productsOfLines && productItem.productsOfLines[area]) {
      // Попробуем сохранить текущий выбранный цвет, если есть в этом area
      const colorItems = productItem.productsOfLines[area];
      const colorItem = colorItems.find(item => item.color === selectedColor) || colorItems[0];
      if (colorItem) {
        navigate(PRODUCT_ROUTE + "/" + colorItem.id);
      }
    }
  };

  ///    Breadcrumbs  компонент пути Главная / Каталог / Сплит-системы / Напольно-потолочные сплит-системы

  //    let breadcrumbs = [{ label: "Главная", path: "/" }, { label: "Каталог", path: "/catalog" }];
//  <Breadcrumbs pathSegments={breadcrumbs} />

  return (
      <>
        <RequestPriceModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            productItem={productItem} // Передаем название товара
        />
        <Breadcrumbs products={productItem} />  

        <Container className="product-card pt-4 mb-5">
          <Row>
            <Col xs={4}>
              <ImageGallery key={productItem.id} productItem={productItem}/>
            </Col>
            <Col xs={8}>
              <h1>{productItem.name}</h1>
              <span className="art-nmb ">Код: {productItem.code} </span>
              <div className="d-flex align-items-start mt-4">
                <div className="first-product-data w-50 pe-4">
                  <div className="model-ac">
                    <p className="fw-bolder">Площадь помещения, м<sup>2</sup></p>
                    {productItem.productsOfLines && Object.keys(productItem.productsOfLines).map((area) => (
                    <Button
                      key={area}
                      variant={selectedArea === area ? "success" : "outline-secondary"}
                      className="me-2 rounded-4"
                      onClick={() => handleAreaSelect(area)}
                    >
                      {area}
                    </Button>
                  ))}                  
                  {selectedArea && productItem.productsOfLines[selectedArea]?.length > 1 && (
                    <div className="mt-3">
                      <p className="fw-bold mb-2">Цвет внутреннего блока:</p>
                      {productItem.productsOfLines[selectedArea].map((item) => {
                        const colorCode = colorMap[item.color] || "#FFFFFF";
                        const isSelected = item.color === selectedColor;

                        return (
                          <Button
                            key={item.id}
                            variant={isSelected ? "success" : "outline-secondary"}
                            className="me-2 mb-2 rounded-4"
                            href={PRODUCT_ROUTE + "/" + item.id}
                            onMouseEnter={() => setHoveredColor(item.color)}
                            onMouseLeave={() => setHoveredColor(null)}
                            style={{
                              backgroundColor:
                                hoveredColor === item.color && !isSelected
                                  ? colorCode
                                  : undefined,
                              color:
                                hoveredColor === item.color && !isSelected
                                  ? isLightColor(colorCode)
                                    ? "black"
                                    : "white"
                                  : undefined,
                              border:
                                hoveredColor === item.color && !isSelected && isLightColor(colorCode)
                                  ? "1.5px solid #ccc"
                                  : undefined,
                            }}
                          >
                            {item.color}
                          </Button>
                        );
                      })}
                    </div>
                  )}

                  </div>
                  <div className="product-basic-info my-4">
                    <p className="mb-2 fw-bolder">Характеристики</p>
                    <ul class="products-list ps-0">
                      <li className="products-list__elem d-flex mb-1 align-items-baseline">
                        <span className="products-list__name">Бренд</span>
                        <span className="products-list__dots flex-grow-1"></span>
                        <div className="products-list__value"><a href="/catalog/brands/airwave/">{productItem.brand}</a></div>
                      </li>
                      <li className="products-list__elem d-flex mb-1 align-items-baseline">
                        <span className="products-list__name">Серия</span>
                        <span className="products-list__dots flex-grow-1"></span>
                        <div className="products-list__value">{productItem.series}</div>
                      </li>
                      <li className="products-list__elem d-flex mb-1 align-items-baseline">
                        <span className="products-list__name">Инверторная технология</span>
                        <span className="products-list__dots flex-grow-1"></span>
                        <div className="products-list__value">{productItem.inverter}</div>
                      </li>
                      <li className="products-list__elem d-flex mb-1 align-items-baseline">
                        <span className="products-list__name">Гарантия</span>
                        <span className="products-list__dots flex-grow-1"></span>
                        <div className="products-list__value">{productItem.guarantee}</div>
                      </li>
                    </ul>
                    <ExpandableText text={productItem.description} />
                  </div>
                </div>
                <div className="price-wrapper w-50 rounded-4 p-4">
                  {productItem.isSale && productItem.countour > 0 && (
                      <div className="price mb-2">
                        <span className="old-price pe-2 text-decoration-line-through">{productItem.price}<span className="rub-icon">₽</span></span>
                        <span className="first-price fw-bolder text-danger">{productItem.salePrice}<span className="rub-icon">₽</span></span>
                      </div>
                  )}
                  {!productItem.isSale && productItem.countour > 0 && (
                      <div className="price mb-2">
                        <span className="first-price fw-bolder">{productItem.price}<span
                            className="rub-icon">₽</span></span>
                      </div>
                  )}
                  {productItem.countour > 0 && (
                      <span className="availability availability_in-stock d-flex align-items-center mb-4">В наличии {productItem.countour} шт.</span>
                  )}
                  {productItem.countour <= 0 && (
                      <span className="availability availability_in-stock-null d-flex align-items-center mb-4 text-danger">Нет в наличии</span>
                  )}
                  <div>
                    {productItem.countour > 0 && ((product.getBasketCount(productItem) === 0 ? (
                            <div
                                className="carticon-btn text-light ms-auto d-flex align-items-center bg-danger rounded-4 p-2 justify-content-center"
                                onClick={() => {
                                  if (productItem.price > 0) {
                                    product.addBasketProduct(productItem)
                                    setCount(count + 1)
                                  }
                                }}>
                              <CartPlus className="me-2"/>Добавить в корзину
                            </div>
                        ) : (
                            <div className="d-flex align-items-center justify-content-start">
                              <div className="carticonminus text-light" onClick={() => {
                                if (productItem.price > 0) {
                                  setCount(product.getBasketCount(productItem) - 1)
                                  product.changeCountBasketProduct(productItem, product.getBasketCount(productItem) - 1)
                                }
                              }}><CartDash /></div>
                              <span className="d-block px-4 text-success">Товар в корзине ({product.getBasketCount(productItem)})</span>
                              <div className="carticonplus text-light" onClick={() => {
                                if (productItem.price > 0) {
                                  setCount(product.getBasketCount(productItem) + 1)
                                  product.changeCountBasketProduct(productItem, product.getBasketCount(productItem) + 1)
                                }
                              }}><CartPlus /></div>
                                <Button variant={"outline-danger"} 
                                      className="carticonplus fw-bold" 
                                      style={{ 
                                        backgroundColor: '#e74c3c', 
                                        color: 'white',
                                        marginLeft: '5px'
                                      }} 
                                      onClick={() => {
                                if (productItem.price > 0) {
                                  product.changeCountBasketProduct(productItem, 0)
                                  setCount(0)
                                }
                              }}><CartX/></Button>
                            </div>
                        ))
                    )}
                    {productItem.countour <= 0 && (
                        <Button variant="dark" className="rounded-4" onClick={() => setModalShow(true)}>
                          Запросить цену
                        </Button>
                    )}
                  </div>
                </div>

              </div>
            </Col>
            <Col xs={12}>
              <Tabs
                  defaultActiveKey="Specifications"
                  id="uncontrolled-tab-example"
                  className="mb-3 product-tabs"
              >
                <Tab eventKey="Specifications" title="Характеристики">
                  {productItem.attributes
                    ?.filter((info) =>
                      !["URL Megamarket", "URL Ozon", "Модельный ряд"].includes(info.name)
                    )
                    .map((info, index) => {
                      let displayName = info.name;
                      let displayValue = info.value;
                    
                      // Изменяем названия атрибутов
                      if (info.name === "Wi-Fi (Да/Нет/WI-fi Ready)") {
                        displayName = "Wi-Fi";
                      }
                      if (info.name === "Инвертор (Да / Нет)") {
                        displayName = "Инверторная технология";
                      }
                    
                      // Кастомные значения (пример с "Бесплатный монтаж")
                      if (info.name === "Бесплатный монтаж") {
                        displayValue = info.value === "1" ? "Да" : "Нет";
                      }
                    
                      return (
                        <div
                          key={info.id}
                          className={index % 2 === 0 ? "p-2" : "p-2 gray-tab-item"}
                        >
                          {displayName}: {displayValue}
                        </div>
                      );
                    })}
                </Tab>
                <Tab eventKey="Description" title="Описание">
                  <p>{productItem.description}</p>
                </Tab>
                <Tab eventKey="Sertificates" title="Сертификаты и инструкции">
                  Сертификаты и инструкции
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Container>
        
      </>
  );
}

export default ProductCard;